<template>
  <div class="returnOrder">
	<header-com  />
	
	<van-list v-model="isLoading"
			  :finished="isFinished"
			  finished-text=" "
			  :offset="100"
			  :immediate-check="false"
			  @load="getOrderReturnList"
			  v-if="list.length>0">
	  <ul>
		<li v-for="(item, index) in list" :key="index">
		  <order-item-com :item="item"  :stateName="stateObj[item.state]">
			<!--待退回-->
			<div slot="btnGroup" v-if="item.state === 10">
			  <div class="button"
				   @click="$router.push({name:'sendBack',query:{from:'2',id:item.id}})">
				立即退回</div>
			</div>
			<!--鉴定未通过-->
			<div slot="btnGroup" v-if="item.state === 60">
			  <div class="button" @click="$router.push({name:'identificationDetail',query:{id:item.id}})">查看鉴定结果</div>
			</div>
			<!---->
			<div slot="btnGroup" v-if="item.state === 80">
			  <div class="button" @click="showWuLiuPopup(item)">查看物流</div>
			</div>
		  </order-item-com>
		</li>
	  </ul>
	  
	</van-list>
 
	<no-data v-else></no-data>
	<!--物流弹窗-->
	<wu-liu-popup ref="wuLiuPopup" ></wu-liu-popup>
	
  </div>
</template>

<script>
  import orderApi from '@api/order'
  export default {
    name: 'returnOrder',
    components: {},
    data() {
      return {
        isLoading: false,
        isFinished: false,
        list: [],
        pageConfig: {
          pageNum:1,
          pageSize:10,
          total:0
        },
       stateObj:{
          10:'待退回',
          20:'平台待收货',
          30:'待鉴定',//平台已收货
          40:'待收款',
          50:'已收款',//已退款
		  60:'鉴定未通过',
          70:'平台待发货',
          80:'已退回',//平台已发货
          90:'已完成',//用户确认收货
          100:'已拒绝',
          110:'已取消',
        }
	  }
    },
    watch: {},
    computed: {},
    created() {
       this.getOrderReturnList()
    },
    mounted() {
    },
    methods: {
      getOrderReturnList() {
        orderApi.getOrderReturnList({
          ...this.pageConfig,
		}).then(res=>{
          let list = [...this.list];
          this.isLoading = false;
          this.list = list.concat(res.result);
          this.pageConfig.total = res.total;
          if(this.list.length >= this.pageConfig.total){
            this.isFinished = true;
          }else {
            this.pageConfig.pageNum++;
          }
		})
      },
      // 查看物流
      showWuLiuPopup(item){
        orderApi.getOrderDetail({
          orderCode:item.orderCode
        }).then(res=>{
          this.$refs['rulePopup'].show(res)
        });
      },
	}

  }
</script>

<style lang="scss" scoped>
.returnOrder{
  padding: 120px 40px 0;
}
</style>
